import { onRequest, RequestMethod } from "common/axios/axios"
import { getApiUrl } from "common/axios/getApiUrl"

export class ScheduleRepository {
    // 일정 후보 생성
    static onPostCreateSchedule = (params: any) => {
        return onRequest({
            url: getApiUrl('scheduleVote'),
            method: RequestMethod.POST,
            params
        })
    }

    // 일정 후보 목록 조회
    static onGetSchedules = (meetingId: string) => {
        return onRequest({
            url: `${getApiUrl('schedules')}/${meetingId}/schedules`,
            method: RequestMethod.GET
        })
    }

    // 일정 시간 수정 — 시작/종료 datetime 갱신 (주최자만 가능, 백엔드 검증).
    // 모임 진행 중 시간 연장에 사용. scheduleId 는 confirmedScheduleId.
    static onPutSchedule = (scheduleId: string, params: {
        startDatetime: string;  // ISO 8601
        endDatetime: string;    // ISO 8601
    }) => {
        return onRequest({
            url: `${getApiUrl('scheduleConfirm')}/${scheduleId}`,
            method: RequestMethod.PUT,
            params
        })
    }

    // 일정 투표
    static onPostVoteSchedule = (scheduleId: string, params: any) => {
        return onRequest({
            url: `${getApiUrl('scheduleVote')}/${scheduleId}/vote`,
            method: RequestMethod.POST,
            params
        })
    }

    // 일정 확정
    static onPostConfirmSchedule = (scheduleId: string) => {
        return onRequest({
            url: `${getApiUrl('scheduleConfirm')}/${scheduleId}/confirm`,
            method: RequestMethod.POST
        })
    }

    // 일정 수정
    static onPutUpdateSchedule = (scheduleId: string, params: any) => {
        return onRequest({
            url: `${getApiUrl('scheduleVote')}/${scheduleId}`,
            method: RequestMethod.PUT,
            params
        })
    }

    // AI 일정 추천
    static onGetAiRecommendSchedule = (meetingId: string) => {
        return onRequest({
            url: `${getApiUrl('scheduleAiRecommend')}/${meetingId}/schedules/ai-recommend`,
            method: RequestMethod.GET
        })
    }

    // === 새로운 일정 제안 시스템 ===

    // 내 일정 제안 조회
    static onGetMyProposals = (meetingId: string) => {
        return onRequest({
            url: `${getApiUrl('scheduleStatistics')}/${meetingId}/my-proposals`,
            method: RequestMethod.GET
        })
    }

    // 일정 제안 생성 (최대 3개) - 기존 제안은 자동 삭제됨
    static onPostCreateProposals = (params: {
        meetingId: string;
        proposals: Array<{
            startDatetime: string; // ISO 8601 format
            endDatetime: string;   // ISO 8601 format
        }>;
    }) => {
        return onRequest({
            url: getApiUrl('scheduleProposals'),
            method: RequestMethod.POST,
            params
        })
    }

    // 시간대별 통계 조회
    static onGetTimeSlotStatistics = (meetingId: string) => {
        return onRequest({
            url: `${getApiUrl('scheduleStatistics')}/${meetingId}/schedule-statistics`,
            method: RequestMethod.GET
        })
    }

    // 시간대 투표 (토글)
    static onPostVoteTimeSlot = (params: {
        meetingId: string;
        date: string;      // YYYY-MM-DD
        startTime: string; // HH:mm
    }) => {
        return onRequest({
            url: `${getApiUrl('scheduleProposalVote')}/vote`,
            method: RequestMethod.POST,
            params
        })
    }

    // 제안된 시간대로 일정 확정
    static onPostConfirmFromProposal = (params: {
        meetingId: string;
        startDatetime: string; // ISO 8601 format
        endDatetime: string;   // ISO 8601 format
    }) => {
        return onRequest({
            url: `${getApiUrl('scheduleConfirmFromProposal')}/confirm-from-proposal`,
            method: RequestMethod.POST,
            params
        })
    }
}
